<script>
export default {
	name: 'TPadding',
	inheritAttrs: false,
	computed: {
		styles() {
			let style = '';
			let props = this.$attrs;
			switch (true) {
			case ('padding' in props): {
				return `padding: ${this.$attrs.padding};`;
			}
			case ('right' in props): {
				style += `padding-right: ${this.$attrs.right};`;
				break;
			}
			case ('left' in props): {
				style += `padding-left: ${this.$attrs.left};`;
				break;
			}
			case ('top' in props): {
				style += `padding-top: ${this.$attrs.top};`;
				break;
			}
			case ('bottom' in props): {
				style += `padding-bottom: ${this.$attrs.bottom};`;
				break;
			}
			default: break;
			}
			return style;
		}
	},
	render(createElement) {
		if (this.$scopedSlots.default) {
			return createElement('span', { style: this.styles }, this.$scopedSlots.default({}));
		} else return null;
	}
};
</script>
